import React from "react";
import EvoucherSalesReport from "./EvoucherSalesReport";
import { Grid } from "@mui/material";

const SalesReports = () => {
  return (
    <Grid container display={"flex"}>
      <Grid
        my={4}
        width={"100%"}
        display={"flex"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <EvoucherSalesReport
          data={[]}
          title={"Summary Report"}
          heading={`End of Day Summary Report`}
          type={"eod"}
        />
        <EvoucherSalesReport
          data={[]}
          title={"End Of Day Report"}
          heading={"End of Day Record"}
          type={"summary"}
        />
      </Grid>
    </Grid>
  );
};

export default SalesReports;
